// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__3DX6d","inputDescription":"styles_inputDescription__3pOFy"};